import SuccessIcon from "./successIcon";
import FailIcon from "./failIcon";
import WarnIcon from "./warnIcon";

const AnimatedIcons = { SuccessIcon, FailIcon, WarnIcon };

export default AnimatedIcons;
